import { render, staticRenderFns } from "./PolicyBenefitOptions.vue?vue&type=template&id=5ab6d3ed"
import script from "./PolicyBenefitOptions.vue?vue&type=script&lang=js"
export * from "./PolicyBenefitOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports